<template>
  <transition v-if="loading" name="fade">
    <BaseCard cardClasses="mt-3" :sticky="true">
      <template v-slot:header>
        <div
          class="
            w-100
            d-flex
            flex-row flex-wrap
            justify-content-between
            align-items-center
          "
        >
          <h3>تغییر وضعیت به تامین کننده</h3>
          <v-spacer></v-spacer>
          <div>
            <v-btn dark color="blue" @click="changeTobusinessSubmit()">
              ذخیره
            </v-btn>
          </div>
        </div>
      </template>
      <template>
        <ValidationObserver ref="obs">
          <v-form v-if="true" class="mb-4" ref="form">
            <v-sheet   outlined shaped class="px-2 px-md-7 my-4">
              <v-container class="my-8">
                 <v-row>
                  <v-col cols="12" >
                    <div class="d-flex">
                      <HelperComponent helperId="how-i-work" class="mt-1" />
                      <ValidationProvider
                        name="نوع فعالیت خود را انتخاب کنید"
                        vid="creatorGender"
                        rules="required"
                      >
                        <v-radio-group
                          slot-scope="{ errors }"
                          :error-messages="errors"
                          :disabled="freezer"
                          v-model="form.isManufacturer"
                          label="نوع فعالیت خود را انتخاب کنید"
                          class="mt-0 text-right"
                          row
                          @change="changeSupplierProductCategoryTypes"
                        >
                          <v-radio
                            class=""
                          label="صنعتگر هستم( سازنده صنعتی/طراح و مشاور)"
                            :value="true"
                            style="margin-right: 0; margin-left: 10px"
                          ></v-radio>
                          <v-radio
                            class=""
                          label="فروشنده و تاجر هستم"
                            :value="false"
                            style="margin-right: 0; margin-left: 10px"
                          ></v-radio>
                        </v-radio-group>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-row>
                <v-row class="w--100">
                  <v-col cols="12">
                    <h4 class="mb-2 fieldset-title">
                      {{ categorySelectionLabel }}
                    </h4>
                  </v-col>

                  <v-col cols="12" sm="6">
                    <v-select
                      label="نوع فعالیت"
                      outlined
                      persistent-hint
                      item-text="displayName"
                      item-value="title"
                      dense
                      required
                      hide-details
                      :menu-props="{
                        closeOnClick: true,
                        closeOnContentClick: true,
                      }"
                      :disabled="form.isManufacturer == null"
                      return-object
                      v-model="merchantCategoryTypes"
                      :items="filteredMerchantCategoryTypeItems"
                      @change="getCategoriesTreeList"
                      :hint="merchantCategoryTypeHint"
                    />
                  </v-col>
                </v-row>

                <template v-if="activeSelectedItem">
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        label="جست و جوی حوزه فعالیت"
                        outlined
                        dense
                        type="text"
                        required
                        v-model="searchTreeList"
                        @input="handleSearch"
                        append-icon="mdi-magnify"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card outlined>
                        <v-card-title>
                          <span class="blue--text text--darken-5">{{
                            activeSelectedItem.item.displayName
                          }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-treeview
                            open-on-click
                            ref="treeView"
                            item-text="name"
                            item-key="id"
                            item-children="subcategories"
                            item-disabled="disabled"
                            :items="activeSelectedItem.treeList"
                            :search="searchTreeList"
                            color="primary"
                            transition
                            :open.sync="activeSelectedItem.openTreeItem"
                            return-object
                          >
                            <template v-slot:label="props">
                              <div class="treeCheckBox">
                                <v-checkbox
                                  v-if="props.item.isLeaf"
                                  v-model="activeSelectedItem.activeTreeItem"
                                  class="mt-0"
                                  hide-details
                                  :value="props.item"
                                  :label="props.item.name"
                                  @change="selectTree"
                                >
                                </v-checkbox>
                                <span v-else class="f-s-13 text-right">{{
                                  props.item.name
                                }}</span>
                              </div>
                            </template>
                          </v-treeview>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </template>
                <v-row
                  ref="tables"
                  class="mt-5"
                  v-if="merchantCategoriesBreadCrumbList.length"
                >
                  <v-col cols="12" md="6">
                    <BusinessInformationTable
                      :items="merchantCategoriesBreadCrumbList"
                      :fields="merchantCategoryFields"
                      @removeFromList="removeMerchantCategoriesBreadCrumbList"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
           
          </v-form>
        </ValidationObserver>

      </template>
    </BaseCard>
  </transition>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
const merchantRepository = () => RepoFactory.get('merchant');
const enumsRepository = () => RepoFactory.get('enums');
const categoryRepository = () => RepoFactory.get('category');
const supplierRepository = () => RepoFactory.get('supplier');
const supplierProductRepository = () => RepoFactory.get('supplierProduct');
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import Swal from 'sweetalert2';
import BusinessInformationTable from '../../businessInformation/components/BusinessInformationTable.vue'

export default {
  name: 'ChangeToBusinessForm',
  props: {
    freezer: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [reusableMethodsMixin, asyncLoadMixin],
  components: {
    BusinessInformationTable,
    datePicker: VuePersianDatetimePicker,
    Multiselect,
  },
  data() {
    return {
      validationErr: [],
      counter: 1,
      checkbox: false,
      formType: '1',
      merchantCategoryTypeItems: [],
      registerTypeList: [],
      selectionItems: [],
      supplierProductCategoryTypes: [],
      activeTreeItem: [],
      openTreeItem: [],
      merchantCategoriesBreadCrumbList: [],
      hasIsManufacturerInQuery: false,
      form: {
        categoryTypes: [],
        categoryIds: [],
        isManufacturer: true,
      },
      merchantCategoryFields: [
        {
          value: 'mainCategoryTitle',
          text: 'نوع فعالیت',
          sortable: false,
        },
        {
          value: 'breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
        {
          value: 'actions',
          text: 'حذف',
          sortable: false,
        },
      ],

      merchantCategoryTypes: [],
      activeSelectedItem: null,
      defaultOpenedTreeView: null,
      loading: false,
      loader: null,
      searchTreeList: null,
      validationErrors: {
        merchantNameErrors: [],
        companyNameErrors: [],
      },
    };
  },

  computed: {
    ...mapGetters([
      'merchantBaseUrl',
      'productBaseUrl',
      'userBusinessInformation',
    ]),
    filteredMerchantCategoryTypeItems() {
      return this.merchantCategoryTypeItems.filter((el) =>
        this.supplierProductCategoryTypes.includes(el.title)
      );
    },
    categorySelectionLabel() {
      if (this.form.isManufacturer) {
        return ' انتخاب دسته بندی های خدمات و محصولات';
      }
      return 'انتخاب دسته بندی های کالا و تجهیزات صنعتی';
    },
    merchantCategoryTypeHint() {
      if (!this.hasIsManufacturerInQuery) {
        return 'ابتدا نوع فعالیت خود را انتخاب کنید';
      }
      return '';
    },

  },
  created() {
    if (this.$store.getters.authorize == 'merchant' && !this.$store.getters.userDetails.roles.includes('supplier')) {
               this.loader = this.$loading.show();
    this.$store
      .dispatch('getSupplierInformation')
      .then((data) => {
        this.fillValues(data);
        this.getData();
      })
      .catch((error) => {
        Helper.handleErrors(error, this);
      });
            } 
        else {
          if (this.currentMerchant) {
          this.loader = this.$loading.show();
          this.$store.dispatch('getMerchantInformation')
            .then((data) => {
              this.fillValues(data);
              this.getData();
      })
      .catch((error) => {
        Helper.handleErrors(error, this);
      });
                }
            }
    
  },
  methods: {
    
    getData() {
      Promise.all([
        this.getMerchantCategoriesBreadCrumb(),
        this.getCategoryTypeItems(),
        this.getRegisterCompanyTypeItems(),
        this.getSupplierProductCategoryTypes(),
      ])
        .then(() => {
          this.loading = true;

        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => this.loader.hide());
    },
    fillValues(data) {
      this.form.categoryTypes = data.categoryTypes?.length
        ? data.categoryTypes
        : [];
 
      this.form.categoryIds = data.categoryIds?.length ? data.categoryIds : [];
      this.form.isManufacturer = data.isManufacturer;

    },
    handleSearch(val) {
      if (val) {
        this.$refs.treeView.updateAll(true);
      } else {
        this.$refs.treeView.updateAll(false);
        this.activeSelectedItem.openTreeItem = this.defaultOpenedTreeView;
      }
    },

    changeSupplierProductCategoryTypes() {
      this.merchantCategoryTypes = [];
      this.activeSelectedItem = null;
      this.form.categoryIds = [];
      this.form.categoryTypes = [];
      this.merchantCategoriesBreadCrumbList = [];
      this.getSupplierProductCategoryTypes();
    },
    getSupplierProductCategoryTypes() {
      return new Promise((resolve, reject) => {
        const params = {
          supplierIsManufacturer: this.form.isManufacturer,
        };
        supplierProductRepository()
          .getSupplierProductCategoryTypes(this.productBaseUrl, params)
          .then(({ data }) => {
            this.supplierProductCategoryTypes = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async checkValidName(event, errorName, name) {
      if (event.target.value == '') {
        this.validationErrors[errorName] = [`${name} الزامی است`];
        return;
      }
      if (event.target.value.length < 3) {
        this.validationErrors[errorName] = [
          `${name} حداقل بایستی 3 کاراکتر باشد`,
        ];
        return;
      }
      try {
        const params = {
          merchantName: event.target.value,
          id: this.userBusinessInformation.merchantId,
        };
        const response = await merchantRepository().forbidenNamesValidate(
          this.merchantBaseUrl,
          params
        );
        if (!response.data.isValid) {
          this.validationErrors[errorName] = [response.data.message];
        } else {
          this.validationErrors[errorName] = [];
        }
      } catch (error) {
        this.validationErrors[errorName] = [];
      }
    },

    selectTree(val) {
      if (val && val.length) {
        this.getMerchantCategoriesByIds();
      }
    },

    async checkValidName(event, errorName, name) {
      if (event.target.value == '') {
        this.validationErrors[errorName] = [`${name} الزامی است`];
        return;
      }
      if (event.target.value.length < 3) {
        this.validationErrors[errorName] = [
          `${name} حداقل بایستی 3 کاراکتر باشد`,
        ];
        return;
      }
      try {
        const params = {
          merchantName: event.target.value,
          id: this.userBusinessInformation.merchantId,
        };
        const response = await merchantRepository().forbidenNamesValidate(
          this.merchantBaseUrl,
          params
        );
        if (!response.data.isValid) {
          this.validationErrors[errorName] = [response.data.message];
        } else {
          this.validationErrors[errorName] = [];
        }
      } catch (error) {
        this.validationErrors[errorName] = [];
      }
    },
    async changeTobusinessSubmit() {
    const clonedFormData = JSON.parse(JSON.stringify(this.form));
      if (!clonedFormData.categoryIds.length) {
        Swal.fire({
          icon: 'error',
          title: 'خطا',
          html: "لطفا فعالیت خود را مشخص کنید",
          confirmButtonText: ' بستن',
        });
      }
      console.log('form',this.form);


      this.pruneProperties(clonedFormData);

      const loader = this.$loading.show();

        supplierRepository()
        .changeToBusiness(clonedFormData, this.merchantBaseUrl)
        .then(() => {
          this.$router.replace({ path: '/business-information' });
          Swal.fire({
            icon: 'success',
            title: 'ویرایش انجام شد',
            confirmButtonText: ' بستن',
          });
        })
        .catch((error) => {
          this.validationErr = error.response.data.validationErrors[0];
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
      
      
    },


    label(obj) {
      return obj.name;
    },
    removeMerchantCategoriesBreadCrumbList(item) {
      // step:1 remove from merchant categories list
      this.merchantCategoriesBreadCrumbList =
        this.merchantCategoriesBreadCrumbList.filter(
          (el) => el.categoryId !== item.categoryId
        );
      this.form.categoryIds = this.form.categoryIds.filter(
        (el) => el !== item.categoryId
      );
      // step:2 remove from selected tree items
      if (this.activeSelectedItem) {
        this.activeSelectedItem.activeTreeItem =
          this.activeSelectedItem.activeTreeItem.filter(
            (el) => el.id != item.categoryId
          );
      }
      // step:3 remove from categoryTypes if removed merchant
      // category is not exist in categoryTypes
      const categoryTypeTitle = item.categoryTypeTitle;
      if (
        !this.merchantCategoriesBreadCrumbList.find(
          (el) => el.categoryTypeTitle == categoryTypeTitle
        )
      ) {
        this.form.categoryTypes.splice(
          this.form.categoryTypes.indexOf(categoryTypeTitle),
          1
        );
        this.merchantCategoryTypes.splice(
          this.form.categoryTypes.indexOf(
            (el) => el.title == categoryTypeTitle
          ),
          1
        );
      }
    },




    getCategoriesTreeList(val) {
      const loader = this.$loading.show();
      const param = {};

      // param.categoryTypes = val.map((el) => el.title);
      param.categoryTypes = val.title;

      categoryRepository()
        .getCategoriesList(this.productBaseUrl, param)
        .then((res) => {
          const data = {
            item: val,
            treeList: res.data,
            activeTreeItem: [],
            openTreeItem: res.data,
          };
          this.$set(this.selectionItems, this.selectionItems.length, data);
          this.activeSelectedItem = data;
          this.defaultOpenedTreeView = data.openTreeItem;

          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getRegisterCompanyTypeItems() {
      return new Promise((resolve, reject) => {
        const params = {
          companyTypeGroupId: this.formType,
        };
        merchantRepository()
          .getCompanytypegroupItems(this.merchantBaseUrl, params)
          .then(({ data }) => {
            this.registerTypeList = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getCategoryTypeItems() {
      return new Promise((resolve, reject) => {
        enumsRepository()
          .getEnum('CategoryTypeItems', this.productBaseUrl)
          .then(({ data }) => {
            this.merchantCategoryTypeItems = data;
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getMerchantCategoriesByIds() {
      const ids = this.activeSelectedItem.activeTreeItem.map((el) => {
        return el.id;
      });
      if (this.form.categoryIds == undefined || this.form.categoryIds == null) {
        this.form.categoryIds = [];
      }
      const notExistedItems = [];
      const existedItems = [];
      ids.forEach((id) => {
        if (!this.form.categoryIds.includes(id)) {
          notExistedItems.push(id);
        } else {
          existedItems.push(id);
        }
      });
      if (existedItems.length && !notExistedItems.length) {
        return;
      }

      this.form.categoryIds.push(...notExistedItems);

      const params = {
        ids: this.form.categoryIds.join(','),
      };
      categoryRepository()
        .getMerchantCategoriesByIds(this.productBaseUrl, params)
        .then((res) => {
          this.merchantCategoriesBreadCrumbList = res.data;
          this.activeSelectedItem.activeTreeItem.forEach((el) => {
            if (!this.form.categoryTypes.includes(el.categoryType)) {
              this.form.categoryTypes.push(el.categoryType);
            }
          });
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        });
    },
    asyncUrbanAreas(query) {
      if (query && query.length >= 2) {
        const params = {
          cityId: this.cityId,
          key: query,
        };
        urbanAreasRepository()
          .filterUrbanAreasByCity(this.merchantBaseUrl, params)
          .then((res) => {
            this.urbanareasList = res.data;
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      }
    },
    getMerchantCategoriesBreadCrumb() {
      return new Promise((resolve, reject) => {
        categoryRepository()
          .getMerchantCategoriesBreadCrumb(this.productBaseUrl, {
            MerchantId: this.userBusinessInformation.merchantId,
          })
          .then(({ data }) => {
            this.merchantCategoriesBreadCrumbList = data;
            this.form.categoryIds = [];
            this.merchantCategoriesBreadCrumbList.forEach((element) => {
              this.form.categoryIds.push(element.categoryId);
            });
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#refreshButton {
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding: 10px;
  z-index: 400;
}
.v-treeview {
  height: 200px;
  overflow: scroll;
}
.v-card__title {
  letter-spacing: 0 !important;
}
.multiselect {
  * {
    font-size: 1rem !important;
  }
  .multiselect__tag {
    background: #7a7a7a !important;
  }
  .theme--dark & {
    * {
      background: #1e1e1e;
      color: #ffffff;
    }
  }
}
.f-s-13 {
  font-size: 13px;
}
.v-input--radio-group__input {
  .v-label {
    padding-right: 0 !important;
    text-align: right;
  }
}
</style>
